import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { StockOpname } from 'services/action';

import { Page, Button } from 'ui/components';

import { FormAdjusmentItems, FormInput, FormItems } from './component/form';

const initialState = {
  ready: false,
  data: null,
  form: null,
  items: null,
  adjusment: null,
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [{ ready, form, items, data, adjusment }, setState] =
    React.useState(initialState);

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      type: form?.type,
      note: form?.note,
    };

    if (form?.type === 'opname') {
      payload.items = items;
    }

    if (form?.type === 'adjustment') {
      payload.items = adjusment?.items;
    }

    const submit = await Dispatch(StockOpname.$update(data?.id, payload));

    if (submit?.message === 'success') {
      History.replace(`/inventory/stockopname/${submit?.data?.id}`);
    }
  };

  const $handleItemsOpnameChange = async (i, e) => {
    let newItems = [...items];
    newItems[i][e.target.name] = e.target.valueNumber;

    setState((prevState) => ({ ...prevState, items: newItems }));
  };

  const $handleAdjusmentChange = (v) => {
    setState((prevState) => ({ ...prevState, adjusment: v }));
  };

  React.useEffect(() => {
    const $onLoad = async (id) => {
      const req = await Dispatch(StockOpname.$show(id));

      if (req?.message === 'success' && req?.data !== null) {
        setState((prevState) => ({
          ...prevState,
          data: req?.data,
          ready: true,
        }));
      }
    };

    if (!ready) $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    if (data?.type === 'opname') {
      let it = [];
      if (data?.items) {
        data?.items?.forEach((i) => {
          it?.push({
            item_id: i?.item?.id,
            current_stock: i?.initial_quantity,
            quantity: i?.actual_quantity,
            quantity_defect: i?.defect_quantity,
            unit_name: i?.item?.default_fraction,
          });
        });
      }
      setState((prevState) => ({ ...prevState, items: it }));
    }
  }, [data]);

  return (
    <Page type="form" className="bg-white " onSubmit={$handleSubmit}>
      <Page.Header title="Perbaharui Stockopname" />

      <Page.Body className="d-block px-3">
        <div className="row">
          <div className="col-md-4 border-end ">
            <FormInput data={data} onInputChange={$handleFormChange} />
          </div>
          {form?.type === 'opname' && items && (
            <div className="col-md-8">
              <FormItems
                data={items}
                onInputChange={$handleItemsOpnameChange}
              />
            </div>
          )}

          {form?.type === 'adjustment' && (
            <div className="col-md-8 ">
              <div className="ps-3">
                <FormAdjusmentItems
                  data={data?.items}
                  onInputChange={$handleAdjusmentChange}
                />
              </div>
            </div>
          )}
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/inventory/stockopname`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
